/* eslint-env jquery */

"use strict";

window.players = [];

/**
* Creates the YouTube Iframe API script tag if it does not already exist
*/
const initYoutubeApi = () => {
    let currentScriptTag = document.getElementById("youtube-iframe-api");

    if (!currentScriptTag) {
        var tag = document.createElement("script"),
            firstScriptTag = document.getElementsByTagName("script")[0],
            currentDateInt = parseInt(new Date().getTime(), 10);

        tag.id = "youtube-iframe-api";
        tag.src = "https://www.youtube.com/iframe_api?version=" + currentDateInt;
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
};

/**
* Initializes a YouTube video player
* @param {Object} $videoPlayer - jQuery object of the video player
* @param {string} videoId - YouTube video ID
* @param {boolean} loop - whether to loop the video
* @param {boolean} isMuted - whether to mute the video
* @returns {boolean} - whether the video player was successfully initialized
*/
const startVideo = ($videoPlayer, videoId, loop, isMuted) => {
    let playerTag = $videoPlayer[0].querySelector(".youtube-video-player");

    try {
        window.player = new window.YT.Player(playerTag, {
            videoId: videoId,
            playerVars: {
                showinfo: 0,
                enablejsapi: 1,
                mute: isMuted,
                loop: loop
            },
            events: {
                onStateChange: onPlayerStateChange,
                onReady: onPlayerReady,
            },
        });

        window.players.push(window.player);

        return true;
    } catch {
        return false;
    }
};

let currentVideoPlayer = null;

/**
* Handles the playing state of the video player
* @param {Object} event - the event object
* @returns {void}
*/
const onPlayerStateChange = (event) => {
    const playing = window.YT.PlayerState.PLAYING;
    if (event?.data === playing) {
        if (currentVideoPlayer && currentVideoPlayer !== event.target) {
            currentVideoPlayer?.stopVideo();
        }
        currentVideoPlayer = event.target;
    }
};

/**
* Stops the current video player and sets the new one
* @param {Object} event - the event object
* @returns {void}
*/
const onPlayerReady = (event) => {

    if (currentVideoPlayer && currentVideoPlayer !== event.target) {
        currentVideoPlayer?.stopVideo();
    }
    currentVideoPlayer = event.target;
};

/**
* Initializes the YouTube video player
* @param {Object} $videoPlayer - the target video player element
* @returns {void}
*/
const initPlayer = ($videoPlayer) => {
    const videoId = $videoPlayer.data("video-id");
    const isMuted = $videoPlayer.data("video-muted");
    const isLoop = $videoPlayer.data("video-loop");


    if (!$videoPlayer.hasClass("player-initialized")) {
        initYoutubeApi();

        setTimeout(() => {
            const videoStarted = startVideo($videoPlayer, videoId, isLoop, isMuted);
            if (!videoStarted) {
                initPlayer($videoPlayer);
                return;
            }
            $videoPlayer.addClass("player-initialized");
        }, 1000);
    }
};

/**
* Initializes the YouTube video players and sets autoplay if necessary
*/
(function () {
    $(".youtube-video").each((index, player) => {
        const $videoPlayer = $(player);
        const isAutoplay = $videoPlayer.data("video-auto-play");

        if (isAutoplay) {
            initPlayer($videoPlayer);
        }
    });

    $(".youtube-video").on("click", function (ev) {
        const $videoPlayer = $(ev.target).parents(".youtube-video");
        initPlayer($videoPlayer);
    });
})();
